import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

function LogoutIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M17.7057 7.70568C17.3159 7.31594 16.6841 7.31594 16.2943 7.70568C15.9051 8.09489 15.9045 8.72572 16.293 9.11568L18.17 11H9C8.44771 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H18.17L16.295 14.875C15.9052 15.2648 15.9041 15.8964 16.2925 16.2875C16.6828 16.6806 17.3183 16.6817 17.71 16.29L21.4462 12.5538C21.7521 12.248 21.752 11.752 21.4462 11.4462L17.7057 7.70568ZM4 5H11C11.5523 5 12 4.55228 12 4C12 3.44772 11.5523 3 11 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H11C11.5523 21 12 20.5523 12 20C12 19.4477 11.5523 19 11 19H4V5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default LogoutIcon;
